var _templateObject = _taggedTemplateLiteralLoose(['\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n'], ['\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  display: inline-block;\n  width: ', ';\n  height: ', ';\n'], ['\n  display: inline-block;\n  width: ', ';\n  height: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  font-size: 10px;\n  /* margin: 50px auto; */\n  /* text-indent: -9999em; */\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: ', ';\n  background: linear-gradient(to right, ', ' 10%, rgba(255, 255, 255, 0) 42%);\n  position: relative;\n  animation: ', ' 1.4s infinite linear;\n  transform: translateZ(0);\n  &.stopped {\n    animation-play-state: paused;\n  }\n  &:before {\n    width: 50%;\n    height: 50%;\n    background: ', ' ;\n    border-radius: 100% 0 0 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: \'\';\n  }\n  &:after {\n    background: #fff;\n    width: 75%;\n    height: 75%;\n    border-radius: 50%;\n    content: \'\';\n    margin: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  }\n'], ['\n  font-size: 10px;\n  /* margin: 50px auto; */\n  /* text-indent: -9999em; */\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  background: ', ';\n  background: linear-gradient(to right, ', ' 10%, rgba(255, 255, 255, 0) 42%);\n  position: relative;\n  animation: ', ' 1.4s infinite linear;\n  transform: translateZ(0);\n  &.stopped {\n    animation-play-state: paused;\n  }\n  &:before {\n    width: 50%;\n    height: 50%;\n    background: ', ' ;\n    border-radius: 100% 0 0 0;\n    position: absolute;\n    top: 0;\n    left: 0;\n    content: \'\';\n  }\n  &:after {\n    background: #fff;\n    width: 75%;\n    height: 75%;\n    border-radius: 50%;\n    content: \'\';\n    margin: auto;\n    position: absolute;\n    top: 0;\n    left: 0;\n    bottom: 0;\n    right: 0;\n  }\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React, { Component } from 'react';
import styled, { keyframes } from 'styled-components';

var spin = function spin(props) {
  return keyframes(_templateObject);
};

export var SpinnerContainer = styled.div(_templateObject2, function (props) {
  return props.width;
}, function (props) {
  return props.width;
});
export var Circle = styled.div(_templateObject3, function (props) {
  return props.theme.colours.primary.light;
}, function (props) {
  return props.theme.colours.primary.base;
}, spin, function (props) {
  return props.theme.colours.primary.base;
});

var Spinner = function (_Component) {
  _inherits(Spinner, _Component);

  function Spinner() {
    _classCallCheck(this, Spinner);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Spinner.prototype.render = function render() {
    return React.createElement(SpinnerContainer, {
      width: this.props.width ? this.props.width : '200px'
    }, React.createElement(Circle, {
      className: this.props.stop ? 'stopped' : ''
    }, React.createElement('div', null), React.createElement('div', null), React.createElement('div', null), React.createElement('div', null)));
  };

  return Spinner;
}(Component);

export default Spinner;